import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-three-column',
  templateUrl: './portfolio-three-column.component.html',
  styleUrls: ['./portfolio-three-column.component.scss']
})
export class PortfolioThreeColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
